import { Box, Typography } from "@mui/material";
import { FinancialAssetSubTypeFarsi } from "../../types/FinancialAssets";
import moment from "moment-jalaali";
import { toToman } from "../../utils/Utils";
import GrowthBadge from "../shared/GrowthBadge";

const CardItem = (props) => {
  const { title, value, first } = props;
  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        borderLeft: !first && ((theme) => `1px solid ${theme.palette.grey[6]}`),
      }}
    >
      <Typography variant="subtitle1" color="secondary.main">
        {title}
      </Typography>
      <Box mt={1}>{value}</Box>
    </Box>
  );
};

function AutoInvestmentFundSelectCard({ sx = [], ...props }) {
  const { fund, onClick } = props;
  const items = [
    {
      title: "بازده سالانه",
      value: <GrowthBadge rate={fund.yearlyEfficiency} />,
    },
    {
      title: "زمان توزیع سود",
      value: fund.nextProfitReturnDate ? (
        <Typography variant="h6" color="grey.2">{`${
          moment(fund.nextProfitReturnDate).diff(moment(), "day") + 1
        } روز دیگر`}</Typography>
      ) : null,
    },
    {
      title: "قیمت هر واحد",
      value: (
        <Typography variant="h6" color="grey.2">{`${toToman(
          fund.purchaseNav
        )} تومان`}</Typography>
      ),
    },
  ];
  return (
    <Box
      onClick={onClick}
      sx={[
        {
          width: "100%",
          p: "16px",
          borderRadius: "10px",
          display: "flex",
          flexDirection: "column",
          boxShadow: (theme) => theme.shadows[2],
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <img width={56} height={56} src={fund.iconPath} />
        <Box sx={{ display: "flex", flexDirection: "column", ml: 1 }}>
          <Typography variant="body2" color="secondary.dark">
            {fund.name}
          </Typography>
          <Typography mt={1} variant="subtitle1" color="grey.2">
            {FinancialAssetSubTypeFarsi[fund.assetSubType]}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: "flex", mt: 2 }}>
        {items
          .filter((item) => Boolean(item.value))
          .map((item, index) => {
            return (
              <CardItem
                key={index}
                title={item.title}
                value={item.value}
                first={index === 0}
              />
            );
          })}
      </Box>
    </Box>
  );
}

export default AutoInvestmentFundSelectCard;
